<template>
    <div>
        <div class="row align-items-end">
            <div class="col-xl-3 col-md-4 col-sm-6">
                <label class="w-100">
                    {{ $t('modal.form.product.label') }}
                    <v-select class="select-control"
                              v-model="pagination.product_id"
                              :options="product_select"
                              @input="getData"
                    ></v-select>
                </label>
            </div>
            <div class="col-xl-3 col-md-4 col-sm-6">
                <label class="w-100">
                    {{ $t('modal.form.dealer.label') }}
                    <v-select class="select-control"
                              v-model="pagination.diller_id"
                              :options="dealers_select"
                              @input="getData"
                    ></v-select>
                </label>
            </div>
            <div class="col-xl-3 col-md-4 col-sm-6">
                <label class="w-100">
                    {{ $t('modal.form.warehouse.label') }}
                    <v-select class="select-control"
                              v-model="pagination.warehouse_id"
                              :options="warehouse_select"
                              @input="getData"
                    ></v-select>
                </label>
            </div>
            <div class="col-xl-3 col-md-4 col-sm-6 ms-auto">
                <div class="d-flex justify-content-end w-100">
                    <b-button class="mb-2"
                              @click="postModalOpen"
                              variant="primary"
                    >
                        {{ $t('modal.nameModalPost') }}
                    </b-button>
                </div>
            </div>
        </div>
        
        <div class="w-100">
            <div class="_table mb-3">
                <b-table
                    :fields="fields"
                    :items="dataItems"
                >
                    <template #cell(actions)={item}>
                        <b-button
                            variant="danger"
                            size="sm"
                            @click="deleteModalOpen(item.id)"
                        >
                            <i class="bx bx-trash fs-4"></i>
                        </b-button>
                    </template>
                </b-table>
            </div>
        </div>
        
        <b-pagination
            v-model="pagination.page"
            :total-rows="total"
            :per-page="pagination.pageSize"
            @input="getData"
        ></b-pagination>
        
        <b-modal
            v-model="postModalBool"
            hide-footer
            :title="$t('modal.titlePost')"
            size="lg"
        >
            <PostModal
                :product_select="product_select"
                :warehouse_select="warehouse_select"
                :dealers_select="dealers_select"
                @onClose="postModalClose"
            />
        </b-modal>
        
        <b-modal
            v-model="deleteModalBool"
            hide-footer
            :title="$t('modal.titleDelete')"
        >
            <DeleteModal
                :id="id"
                @onClose="deleteModalClose"
            />
        </b-modal>
    </div>
</template>

<script>
import {getInfoAll} from '../../../api/endpoints/info';
import {getWarehouse} from '../../../api/endpoints/warehouse';
import {getDealers} from '../../../api/endpoints/dealers';
import PostModal from './postModal.vue';
import DeleteModal from './deleteModal.vue'
import {mapActions, mapGetters} from 'vuex';
import {getIncomes} from '../../../api/endpoints/incomes';

export default {
    name: "IncomesVue",
    components: {
        PostModal,
        DeleteModal
    },
    data() {
        return {
            id: null,
            fields: [
                {key: "id", label: this.$t('table.id.label')},
                {key: "product.name", label: this.$t('table.product.label')},
                {key: "dealer.name", label: this.$t('table.dealer.label')},
                {key: "warehouse.name", label: this.$t('table.warehouse.label')},
                {key: "author.full_name", label: this.$t('table.author.label')},
                {key: "quantity", label: this.$t('table.quantity.label')},
                // {key: "status", label: this.$t('table.status.label')},
                // {key: "price", label: this.$t('table.price.label')},
                {key: "actions", label: this.$t('table.actions.label')},
            ],
            postModalBool: false,
            deleteModalBool: false,
            product_select: [],
            warehouse_select: [],
            dealers_select: [],
            pagination: {
                page: 1,
                pageSize: 15,
                product_id: null,
                diller_id: null,
                warehouse_id: null
            },
            total: 1,
            dataItems: [],
            disabled: false,
        }
    },
    computed: {
        ...mapGetters('incomes', [])
    },
    mounted() {
        this.getProductForSelect();
        this.getWarehouseFroSelect();
        this.getDealersForSelect();
        this.getData();
    },
    methods: {
        ...mapActions('incomes', ['getRows', 'getPerPage', 'getCount', 'getData']),
        getProductForSelect() {
            getInfoAll().then(res => {
                this.product_select = res.data.data.map(item => Object.assign({}, {value: item.id, label: item.name}))
            })
        },
        getWarehouseFroSelect() {
            getWarehouse({all: true}).then(res => {
                this.warehouse_select = res.data.data.map(item => Object.assign({}, {value: item.id, label: item.name}))
            })
        },
        getDealersForSelect() {
            getDealers().then(res => {
                this.dealers_select = res.data.data.map(item => Object.assign({}, {value: item.id, label: item.name}))
            })
        },
        onChange(e) {
            this.getCount(e);
        },
        /* ---------- */
        postModalOpen() {
            this.postModalBool = true;
        },
        postModalClose() {
            this.postModalBool = false;
            this.getData()
        },
        deleteModalOpen(id) {
            this.id = id;
            this.deleteModalBool = true
        },
        deleteModalClose() {
            this.deleteModalBool = false;
            this.getData()
        },
        getData() {
            this.disabled = true;
            getIncomes({
                page: 1,
                pageSize: 15,
                product_id: this.pagination.product_id ? this.pagination.product_id.value : this.pagination.product_id,
                diller_id: this.pagination.diller_id ? this.pagination.diller_id.value : this.pagination.diller_id,
                warehouse_id: this.pagination.warehouse_id ? this.pagination.warehouse_id.value : this.pagination.warehouse_id
            }).then((res) => {
                this.dataItems = res.data.data;
                this.total = res.data.total;
                this.disabled = false
            });
        },
    }
    
}
</script>
